module.exports = __webpack_public_path__ + "static/img/toy_collections_en.2340f76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/toy_collections_en.jpg
// module id = l+95
// module chunks = 47